import { useLayoutEffect } from 'react'
import { useLocation } from 'react-router-dom'

export const TD_SESSION_ENTRY_KEY = 'td_session_entry_path'

/**
 * Records the first pathname of this browser tab session (SPA cold load).
 * Used so the home newsletter modal only auto-opens when the user landed on / first,
 * not when they navigate from other in-app routes to home.
 */
function SessionEntryCapture() {
    const location = useLocation()

    useLayoutEffect(() => {
        try {
            if (!sessionStorage.getItem(TD_SESSION_ENTRY_KEY)) {
                sessionStorage.setItem(TD_SESSION_ENTRY_KEY, location.pathname)
            }
        } catch {
            /* ignore */
        }
    }, [location.pathname])

    return null
}

export default SessionEntryCapture
